module.exports = __webpack_public_path__ + "img/product_35.57e3626.webp";